<error-dialog [error]="errorText" [show]="errorDialog"/>
<breadcrumb endText="CCL Tree" [navigations]="breadcrumbNavs" />
<hr />
<div [ngClass]="isOpened? 'border-l p-3 flex flex-col fixed right-0 h-screen lg:w-[225px] w-[190px]' : 'border-l p-3 flex flex-col right-0 fixed h-screen'">
  <div>
    Search and Filter
  </div>
  <hr class="mb-3 mt-1 -ml-3" />
  <div class="flex input">
    <fa-icon [icon]="faMagnifyingGlass" [style]="iconStyle" />
    <input type="text" class="flex-grow w-full border-0 bg-[#F6F7F8] outline-none text-xs" placeholder="Search" [(ngModel)]="searchText" />
  </div>
</div>
<div [ngClass]="isOpened? 'my-5 ml-5 lg:mr-[225px] mr-[190px]' : 'my-5 ml-5 mr-[68px]'">
  <div class="mb-1 flex gap-2 items-center">
    <mat-icon fontIcon="chevron_left" class="hover:bg-gray-200 cursor-pointer rounded" (click)="SubjectList()"></mat-icon>
    <p class="font-medium text-xl ml-1">
      CCL Tree
    </p>
    @if (backNodes.length !== 0) {
      <clear-button (click)="goBackOneNode(backNodes[backNodes.length-1])" [faIcon]="faRotateLeft" text="Back" />
    }
  </div>
  <hr class="mb-6" />
  @if (!isLoading) {
    <div class="relative">
      <div class="border-r absolute w-[200px] overflow-y-auto overflow-x-hidden -mt-3 p-1 mb-5">
        @for (subject of subjectList; track subject) {
          <div>
            <outline-button [marginRight]="true" (click)="changeParentNodeSubject(subject)" [text]="subject.name" addToClass="width: 100%; margin-top: 0.25rem;"/>
          </div>
        }
      </div>
      <div class="ml-[200px]">
        <div class="m-3">
          @if (parentNode != null) {
            <div class="flex justify-between">
              <div class="flex">
                <div class="ml-3">
                  {{parentNode.name}}
                </div>
              </div>
              <div>
                <button (click)="leanringObjectiveClick(parentNode.customcontentlayer_id)" [style]="underlineStyle">
                  Learning Objectives
                </button>
              </div>
            </div>
          }
          <hr class="mt-2 -mx-3"/>
          @for (node of childNodes; track node) {
            <div class="flex w-full mt-2">
              @if (node.name.includes(searchText)) {
                <button (click)="goForwardOneNode(node, parentNode)" class="flex justify-between hover:bg-gray-200 flex-grow ml-10 p-2 rounded">
                  {{node.name}}
                  <fa-icon [icon]="faChevronRight" />
                </button>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
